export const landingPageContent = {
  heroSection: {
    subtitle: "More than just",
    title: "Community Management Solution",
    description: "We are an improved communication system that enhances resident engagement, helps streamline operations, and increases transparency. We also help in better decision making, cost savings, and improving the quality of life.",
    ctaButtons: {
      download: "Download Safelto App",
      resident: "Use Safelto in your browser",
      residentNote: "Residents can create and share guest codes in the browser, no download needed.",
    },
  },
  advantagesSection: {
    title: "Get Many Advantages on Our",
    highlight: "Platform",
    description: "Our platform is designed to simplify your workflow, reduce costs, and improve overall resident satisfaction—all in one easy-to-use solution.",
    cta: "Get Started with Safelto",
  },
  whyChooseUsSection: {
    subtitle: "Why Choose Us",
    title: "Finally, A Better Way To Manage Your",
    estate: 'Estate',
    description: "Introducing a superior optimal management solution with elevated efficiency, and productivity. Here is a smarter way to manage your residents.",
  },
  featuresSection: {
    subtitle: "Features",
    title: "Everything You Need",
    description: "We are your one-stop solution for all your needs.",
  },
  reviewSection: {
    subtitle: "Reviews",
    title: "Loved by Our Customers",
    description:
      `We appreciate your insight and invite you to share your thoughts on your recent experience(s).
      "Your feedback is invaluable in helping us refine our services."
      "We're committed to excellence and would like to hear about your experience with us."`,
  },
  finalCTA: {
    title: "Create an account in",
    highlight: "10 minutes",
    description: "We're excited to invite you to create an account with us! This will give you access to exclusive benefits, easy checkout, and more.",
    buttonText: "Create an account",
  },
}
